import React, { useState, useRef } from "react";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import IntellipayStoreOnlyMode from "./IntellipayStoreOnlyMode";
import { useFireOnceWhenReady } from "../hooks/useFireOnceWhenReady";

export const ModalUpdateIntelliPay = () => {
  const { eventId } = useParams();
  const { user } = useAuthUser();
  const buttonRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [isWidgetReady, setIsWidgetReady] = useState(false);

  const setIsOpenRegister = () => {
    const redirectPath =
      user.role === "university" ? "/university/account" : "/athlete/account";
    window.location.href = redirectPath;
  };

  useFireOnceWhenReady(isWidgetReady, () => {
    buttonRef.current?.click();
    setLoading(false);
  });

  return (
    <>
      {loading && (
        <div className="flex absolute top-0 left-0 justify-center items-center h-[100%] w-full bg-black/10">
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            size="4x"
            className="text-blue-800"
          />
        </div>
      )}
      <button
        className="ipayfield hidden"
        data-ipayname="submit"
        ref={buttonRef}
      ></button>

      <IntellipayStoreOnlyMode
        userEmail={user.email}
        userId={user.id}
        paymentAmount={0}
        eventId={eventId}
        onWidgetReady={(ready) => {
          if (ready) {
            setIsWidgetReady(true);
            return;
          }
          // Widget failed to load — stop spinning instead of stuck.
          setLoading(false);
          toast.error("We couldn't load the payment form. Please try again.", {
            position: "top-right",
          });
        }}
        onRegistrationSuccess={() => {
          setIsOpenRegister();
        }}
        closeAction={true}
        onClose={() => {
          const redirectPath =
            user.role === "university"
              ? "/university/account"
              : "/athlete/account";
          window.location.href = redirectPath;
        }}
      />
    </>
  );
};
